export default "__VITE_ASSET__DzhW$up8__"